import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { PasswordResetComponent } from '@app/core/user/components/password-reset/password-reset.component';

@NgModule({
  imports: [CommonModule, ReactiveFormsModule],
  declarations: [PasswordResetComponent],
  exports: [PasswordResetComponent],
  entryComponents: [PasswordResetComponent]
})
export class PasswordResetModule {}
